<template>
<div>
  <div v-if="!testing">
    <h3 class="title is-4">Assesment Builder</h3>
    <div class="columns">
      <div class="column">
        <select-input
          required
          :value="assessor.assessible_type"
          @input="updateAssessibleType"
          :items="anchors">
          Type
        </select-input>
      </div>
      <div class="column" v-if="assessor.assessible_type">
        <select-input
          v-if="assessor.assessible_type === 'attribute'"
          required
          :value="assessor.assessible_id"
          @input="updateAssessibleId"
          value-key="id"
          label-key="title"
          :items="attributeTypeList">
          Attribute
        </select-input>
      </div>
    </div>

    <component 
      v-if="assessor.assessible_type && assessor.assessible_id"
      :is="assessor.assessible_type + '-assessment-builder'"/>

    <route-assessment-builder v-if="assessor.assessible_type === 'route'"/>  

    <action-button v-if="assessor.assessible_type" @click="testing = !testing">Test Assessor</action-button>
    <action-button v-if="assessor.assessible_type" :working="storing" @click="storeAssessor">Store Assessor</action-button>
  </div>
  <div v-else>
    <test-assessor @close-testing="testing = false"/>
  </div>
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import TestAssessor from './TestAssessor'

export default {
  
  components: {
    TestAssessor
  },

  data: () => ({
    storing: false,
    anchors: [
      { label: 'Attribute', value: 'attribute' },
      { label: 'Route', value: 'route' },
    ],
    testing: false
  }),

  beforeDestroy() {
    this.$store.commit('assessor/clearAssessor')
  },

  methods: {
    ...mapMutations('assessor', [
      'updateAssessibleId'
    ]),
    updateAssessibleType(value) {
      this.$store.commit('assessor/setAssessibleType', value)
      if(value === 'attribute') {
        this.loadAttributes()
      }
    },
    loadAttributes() {
      this.$store.dispatch('attributeType/loadAttributeTypeList')
    },
    storeAssessor() {
      this.storing = true
      this.$store.dispatch('assessor/storeAssessor', {
        checkpoint_id: this.checkpoint.id
      }).then(data => {
        this.storing = false
        this.$emit('created', data)
        this.$store.commit('assessor/clearAssessor')
        this.$toast.success('Assessor Created')
        this.$store.dispatch('checkpoint/loadCheckpoint', this.$route.params.checkpoint)
      }).catch(error => {
        this.storing = false
      })
    }
  },

  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ]),
    ...mapGetters('checkpoint', [
      'checkpoint'
    ]),
    ...mapGetters('attributeType', [
      'attributeTypeList',
    ]),
  }



}
</script>